import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import ProductGrid from "../components/ProductGrid";
import Footer from "../components/Footer";

const HomePage = () => {
  return (
    <div className="bg-gray-100">
      <Header />
      <main className="pt-20">
        <Hero />
        <ProductGrid />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
